module.exports = __webpack_public_path__ + "static/media/sad-cry.4d2bf4be.svg";